module.exports = __webpack_public_path__ + "img/luck_draw_title.fab7640b.png";